import { ApiResponse } from './api';

export enum IbanVerificationStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export type IbanVerificationUser = {
  id: number;
  email: string;
  phoneNumber: string;
};

export type IbanVerificationBankType = {
  id: number;
  type: string;
};

export type IbanVerificationStatusType = {
  id: number;
  name: IbanVerificationStatus;
};

export type IbanVerification = {
  id: number;
  userId: number;
  user: IbanVerificationUser;
  iban: string;
  swiftCode: string;
  bankType: IbanVerificationBankType;
  // Resolved from the SWIFT code by the backend; falls back to the name the user typed.
  bankName?: string | null;
  bankNameAr?: string | null;
  ibanCertificateFilename: string;
  // On the list: whether the account this request created is the user's primary account now.
  isPrimaryAccount: boolean;
  // On the list: the account this request created has since been deleted by the user.
  isAccountDeleted?: boolean;
  accountDeletedAt?: Date | string | null;
  status: IbanVerificationStatusType;
  reviewComment?: string;
  reviewedAt?: Date | string;
  reviewedBy?: number;
  userBankId?: number;
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type FetchIbanVerificationResponse = ApiResponse<IbanVerification>;

export type FetchIbanVerificationsResponse = ApiResponse<{
  items: IbanVerification[];
  totalItems: number;
}>;

export type UpdateIbanVerificationStatusRequest = {
  id: number;
  status: string;
  reviewComment?: string;
};

export type UpdateIbanVerificationStatusResponse = ApiResponse<{ message: string }>;

export type ApproveIbanVerificationRequest = {
  id: number;
  status: string;
  reviewComment?: string;
};

export type RejectIbanVerificationRequest = {
  id: number;
  status: string;
  reviewComment?: string;
};
